export type StayCoverageKind = "plan" | "package" | "avulso";

export interface StayReservationCoverageDay {
  id: string;
  stayDate: string;
  status: string;
  dailyChargeSaleItemId: string | null;
  holdContractId: string | null;
}

export interface StayCoverageTarget {
  kind: StayCoverageKind;
  contractId: string | null;
  label: string;
}

export interface CoverageSwapSummary {
  scheduledDayCount: number;
  removableDailyChargeCount: number;
  target: StayCoverageTarget;
}

export function scheduledCoverageDays(days: StayReservationCoverageDay[]): StayReservationCoverageDay[] {
  return days.filter((day) => day.status === "scheduled");
}

export function summarizeCoverageSwap(
  days: StayReservationCoverageDay[],
  target: StayCoverageTarget,
): CoverageSwapSummary {
  const scheduledDays = scheduledCoverageDays(days);
  return {
    scheduledDayCount: scheduledDays.length,
    removableDailyChargeCount: target.kind === "avulso"
      ? 0
      : scheduledDays.filter((day) => day.dailyChargeSaleItemId !== null).length,
    target,
  };
}

export function resolveCurrentCoverage(args: {
  days: StayReservationCoverageDay[];
  contracts: Array<{ id: string; kind: "recurring" | "day_package"; planName: string }>;
}): StayCoverageTarget {
  const scheduledDays = scheduledCoverageDays(args.days);
  const contractId = scheduledDays.find((day) => day.holdContractId)?.holdContractId ?? null;
  if (!contractId) return { kind: "avulso", contractId: null, label: "" };

  const contract = args.contracts.find((candidate) => candidate.id === contractId);
  if (!contract) return { kind: "avulso", contractId: null, label: "" };

  return {
    kind: contract.kind === "recurring" ? "plan" : "package",
    contractId: contract.id,
    label: contract.planName,
  };
}
